<ol class="breadcrumb">
  <li class="breadcrumb-item">
    <a [routerLink]="['Submissions']">
      Submissions
    </a>
  </li>
</ol>
<div *ngIf="userInfo">
<table aria-describedby="Submission Table" class="table submission-table table-striped table-hover">
    <thead>
    <tr>
        <th scope="col" class="notes-header">Notes</th>
        <th scope="col" class="resolution-header">Resolved</th>
        <th scope="col" class="tc-review-header">Reviewed</th>
        <th scope="col" class="fileid-header">File ID</th>
        <th scope="col" class="sample-errors-header">Sample / Errors</th>
        <th scope="col" class="submission-status-header">Status</th>
        <th scope="col" class="received-header">Received (CST)</th>
        <th scope="col" class="project-name-header">Project Name</th>
        <th scope="col" class="reporting-center-header">Reporting Center</th>
        <th scope="col" class="test-type-header">Test Type</th>
        <th scope="col" class="uploader-file-name-header">Uploader File Name</th>
        <th scope="col" class="uuid-header">UUID</th>
    </tr>
    </thead>
    <tbody id="dashboardScrollPane">
    <tr *ngFor="let submission of activeFileRecordList">
        <td class="resolution-cell-1" style="padding-top: 0">
            <mat-icon class="icon" (click)="openNote(submission)">insert_comment</mat-icon>
            <span id="{{ 'badge'+ submission.uuid }}" class="badge" [hidden]="!submission.notes">{{badgeCount}}</span>
        </td>
        <td class="resolution-cell-2">
            <mat-checkbox color="primary" [checked]="submission.resolution"
                          (change)="resolve($event.checked,submission.uuid)"></mat-checkbox>
        </td>
        <td class="tc-review-cell">
            <mat-checkbox type="checkbox" [checked]="submission.tcReview"
                          (change)="review($event.checked,submission.uuid)" color="primary">
            </mat-checkbox>
        </td>
        <td class="fileid-cell">
            <mat-icon matTooltip="FHIR Sample Data Available" *ngIf="submission.fhirInd" svgIcon="fhir" class="material-icons--outline icon fhir"></mat-icon>
            <mat-icon matTooltip="DSA Antibody FHIR Record" *ngIf="submission.testType === 'DSA Antibody'" svgIcon="fhir_outline" class="material-icons--outline icon fhir"></mat-icon>
            <mat-icon matTooltip="Correction" class="material-icons--outline icon corrections" *ngIf="submission.correctionInd">create
            </mat-icon>
            <span matTooltip={{submission.hmlId}} (click)="displaySourceDialog(submission.uuid, submission.hmlId, submission.uploaderFileName, submission.status, submission.testType)">{{submission.hmlId}}</span>
        </td>
        <td class="sample-errors-cell">
            <a [routerLink]="['submission',submission.uuid]">
                <div class="status-button"><span class="sample-count">{{submission.sampleCount}}</span> / <span
                    class="error-count">{{submission.errorCount>0? submission.errorCount : '-'}}</span></div>
            </a>
        </td>
        <td *ngIf="submission.status === 'Success' || (!userInfo.internalUser && submission.status != 'Failed') ; else showErrorIcon" class="submission-status-cell">
            <div class="submission-status">{{submission.status}}</div>
        </td>

        <ng-template #showErrorIcon>
            <td class="submission-status-cell" style="padding-top: 0">

              <mat-icon matTooltip="Click to view error information." class="icon info" [hidden]="!submission.status" (click)="displayErrorDialog(submission.uuid)">error_outline</mat-icon>
              <div class="submission-status" style="padding-top: 12px">{{submission.status}}</div>
            </td>
        </ng-template>

        <td class="received-cell">{{submission.receivedDate}}</td>
        <td matTooltip={{submission.projectName}} class="project-name-cell">{{submission.projectName}}</td>
        <td class="reporting-center-cell">{{submission.reportingCenter}}</td>

        <div *ngIf="submission.testType==='Blood Group Antigens'; then thenBlock else elseBlock"></div>
            <ng-template #thenBlock><td class="test-type-cell" >BGA</td></ng-template>
            <ng-template #elseBlock><td class="test-type-cell" >{{submission.testType}}</td></ng-template>

        <td matTooltip={{submission.uploaderFileName}} class="uploader-file-name-cell">{{submission.uploaderFileName}}</td>
        <td class="uuid-cell" style="padding-top: 0">
            <mat-icon style="padding-top: 8px" matTooltip="Copy UUID" class="icon copy rotate" (click)="copyMessage($event, submission.uuid)">content_copy</mat-icon>
            <div matTooltip={{submission.uuid}} class="uuid" style="padding-top: 10px">{{submission.uuid}}</div>

      </td>
    </tr>
    <p class="empty-search" *ngIf="activeFileRecordList != null && activeFileRecordList.length === 0">No results found for search criteria entered</p>
  </tbody>
</table>
<div class="table-tools">
    <div class="extract-button" #extractButton (click)="extract()">
        <em class="material-icons file-dwnld">file_download</em>Extract
    </div>
    <div class="pagination-button"><pagination></pagination></div>
</div>
</div>

<modal-component #errorDialog
    [title]="errorModalTitle"
    [data]="{
        resizeOrClose:'close',
        okBtnTitle:'',
        cancelBtnTitle: '',
        editBtnTitle: '',
        resubmitBtnTitle: '',
        footerMessage: 'Access your original file to correct errors. Submit a corrected file.'
    }">
    <div class="error-table">
        <div class="error-header-row">
            <span class="error-location-hdr">Error&nbsp;Location</span>
            <span class="error-desc-hdr">Description</span>
        </div>
        <div *ngFor="let error of errorDetails" class="error-details-row">
            <span class="error-location-cell">{{error.errorLocation}}</span>
            <span class="error-desc-cell">{{error.errorDescription}}</span>
        </div>
    </div>
</modal-component>
